import { authorizeMe, axiosInstance} from './commonHeadApiLogic.js';

// Ensure authorization header is set before making authenticated requests
const withAuthorization = async (apiFunction, ...args) => {
  try {
    await authorizeMe(); // Ensure the Authorization header is set
    return await apiFunction(...args);
  } catch (error) {
    // Handle errors as necessary
    console.error("Error in API request:", error);
    throw error;
  }
};






// UPCOMING
// /api/admins/bookings/upcoming?fromDate=2026-01-15&toDate=2026-12-31


export const getUpcomingBookings = (fromDate, toDate, page, limit) => {
  return withAuthorization(async () => {
    return axiosInstance.get(
      `/api/admins/bookings/upcoming?fromDate=${fromDate}&toDate=${toDate}&page=${page}&limit=${limit}`
    );
  });
};



// PREVIOUS
// {{local}}/api/admins/bookings/previous?fromDate=2025-01-01&toDate=2026-01-14

export const getPreviousBookingsAPI = (
  fromDate,
  toDate,
  page = 1,
  limit = 5
) => {
  return withAuthorization(async () => {
    return axiosInstance.get(
      `/api/admins/bookings/previous`,
      {
        params: {
          fromDate,
          toDate,
          page,
          limit,
        },
      }
    );
  });
};


// {{local}}/api/admins/bookings/6979b8def4c472a17c570090 --PUT method
// {
//   "status": "pending",
//   "paymentStatus":"pending"
// }

// EDIT BOOKING
export const editBookingAPI = (bookingId, data) => {
  return withAuthorization(async () => {
    return axiosInstance.put(
      `/api/admins/bookings/${bookingId}`,
      data
    );
  });
};

// getBookingByIdAPI
export const getBookingByIdAPI = (bookingId) => {
  return withAuthorization(async () => {
    return axiosInstance.get(`/api/admins/bookings/${bookingId}`);
  });
};

// {{local}}/api/admins/bookings
export const createBookingAPI = (payload) => {
  return withAuthorization(async () => {
    return axiosInstance.post("/api/admins/bookings", payload);
  });
};

// {{baseurl}}/api/admins/bookings/assign-photographer
export const AssignPhotographerToBookingAPI = (payload) => {
  return withAuthorization(async () => {
    return axiosInstance.patch("/api/admins/bookings/assign-photographer", payload);
  });
};

// {{local}}/api/admins/photographers/sort?rating=4.6
export const SortPhotographersAPI = (filters = {},page,limit,bookingId) => {
  return withAuthorization(async () => {
    return axiosInstance.get(`/api/admins/photographers/sort`, {
      params: {
         page,
          limit,
          bookingId,
        rating: filters.rating,
        expertise: filters.expertise,
        category: filters.category,
        photographerType: filters.photographerType,
      },
    });
  });
};
// {{local}}/api/admins/photographers/sorted
export const GetToFloatPhotographersgAPI = (page,limit,bookingId) => {
  return withAuthorization(async () => {
    return axiosInstance.get(
      `/api/admins/photographers/sorted`,
      {
        params: {
          page,
          limit,
          bookingId
        },
      }
    );
  });
};


// START UPLOAD
export const startUploadAPI = (payload) => {
  return withAuthorization(async () => {
    return axiosInstance.post("/api/admins/start", payload, { timeout: 600000 });
  });
};


export const getPartUploadUrlAPI = async (payload) => {
  return withAuthorization(() =>
    axiosInstance.post("/api/admins/get-part-url", payload, { timeout: 600000 })
  );
};


// COMPLETE UPLOAD
export const completeUploadAPI = (payload) => {
  return withAuthorization(async () => {
    return axiosInstance.post("/api/admins/complete", payload, { timeout: 600000 });
  });
};

// ABORT UPLOAD
export const abortUploadAPI = (payload) => {
  return withAuthorization(async () => {
    return axiosInstance.post("/api/admins/abort", payload);
  });
};


// export async function getPhotoskeysbyidAPI(page, limit, bookingId = "", photographerId = "") {
//   return withAuthorization(async () => {
    
//     const response = await axiosInstance.get(
//      `/api/admins/datalinks?page=${page}&limit=${limit}&bookingId=${bookingId}&photographerId=${photographerId}`
//     );
//     return response;
//   });
// }




// export async function getImagesUsingKeysAPI(bookingId, key) {
//   return withAuthorization(async () => {

    

//     const response = await axiosInstance.get(
//       `/api/admins/stream/${bookingId}/*${key}`,
//       {
//         responseType: "blob",
//       }
//     );

//     const blobUrl = URL.createObjectURL(response.data);
//     return blobUrl;
//   });
// }




// export async function getPhotoskeysbyidAPI(page, limit, bookingId, photographerId) {
//   return withAuthorization(async () => {
//     const response = await axiosInstance.get(
//      `/api/admins/datalinks?page=${page}&limit=${limit}&bookingId=${bookingId}&photographerId=${photographerId}`
//     );
//     return response;
//   });
// }

// export async function getImagesUsingKeysAPI(bookingId, key) {
//   return withAuthorization(async () => {
//     const response = await axiosInstance.get(
//       `/api/admins/stream/${bookingId}/*${key}`,
//       {
//         responseType: "blob",
//       }
//     );

//     const blobUrl = URL.createObjectURL(response.data);
//     return blobUrl;
//   });
// }


// import { authorizeMe, axiosInstance} from './commonHeadApiLogic.js';

// // Ensure authorization header is set before making authenticated requests
// const withAuthorization = async (apiFunction, ...args) => {
//   try {
//     await authorizeMe(); // Ensure the Authorization header is set
//     return await apiFunction(...args);
//   } catch (error) {
//     // Handle errors as necessary
//     console.error("Error in API request:", error);
//     throw error;
//   }
// };






// // UPCOMING
// // /api/admins/bookings/upcoming?fromDate=2026-01-15&toDate=2026-12-31


// export const getUpcomingBookings = (fromDate, toDate, page, limit) => {
//   return withAuthorization(async () => {
//     return axiosInstance.get(
//       `/api/admins/bookings/upcoming?fromDate=${fromDate}&toDate=${toDate}&page=${page}&limit=${limit}`
//     );
//   });
// };



// // PREVIOUS
// // {{local}}/api/admins/bookings/previous?fromDate=2025-01-01&toDate=2026-01-14

// export const getPreviousBookingsAPI = (
//   fromDate,
//   toDate,
//   page = 1,
//   limit = 5
// ) => {
//   return withAuthorization(async () => {
//     return axiosInstance.get(
//       `/api/admins/bookings/previous`,
//       {
//         params: {
//           fromDate,
//           toDate,
//           page,
//           limit,
//         },
//       }
//     );
//   });
// };


// // {{local}}/api/admins/bookings/6979b8def4c472a17c570090 --PUT method
// // {
// //   "status": "pending",
// //   "paymentStatus":"pending"
// // }

// // EDIT BOOKING
// export const editBookingAPI = (bookingId, data) => {
//   return withAuthorization(async () => {
//     return axiosInstance.put(
//       `/api/admins/bookings/${bookingId}`,
//       data
//     );
//   });
// };

// // getBookingByIdAPI
// export const getBookingByIdAPI = (bookingId) => {
//   return withAuthorization(async () => {
//     return axiosInstance.get(`/api/admins/bookings/${bookingId}`);
//   });
// };

// // {{local}}/api/admins/bookings
// export const createBookingAPI = (payload) => {
//   return withAuthorization(async () => {
//     return axiosInstance.post("/api/admins/bookings", payload);
//   });
// };

// // {{baseurl}}/api/admins/bookings/assign-photographer
// export const AssignPhotographerToBookingAPI = (payload) => {
//   return withAuthorization(async () => {
//     return axiosInstance.patch("/api/admins/bookings/assign-photographer", payload);
//   });
// };

// // {{local}}/api/admins/photographers/sorted
// export const GetToFloatPhotographersgAPI = (page,limit) => {
//   return withAuthorization(async () => {
//     return axiosInstance.get(
//       `/api/admins/photographers/sorted`,
//       {
//         params: {
//           page,
//           limit,
//         },
//       }
//     );
//   });
// };

// // START UPLOAD
// export const startUploadAPI = (payload) => {
//   return withAuthorization(async () => {
//     return axiosInstance.post("/api/admins/start", payload);
//   });
// };

// // UPLOAD CHUNK
// // export const uploadChunkAPI = (formData) => {
// //   return withAuthorization(async () => {
// //     return axiosInstance.post("/api/admins/chunk", formData, {
// //       headers: {
// //         "Content-Type": "multipart/form-data",
// //       },
// //     });
// //   });
// // };

// export const uploadChunkAPI = async (formData) => {
//   return withAuthorization(() =>
//     axiosInstance.post("/api/admins/chunk", formData)
//   );
// };


// // COMPLETE UPLOAD
// export const completeUploadAPI = (payload) => {
//   return withAuthorization(async () => {
//     return axiosInstance.post("/api/admins/complete", payload);
//   });
// };

// // ABORT UPLOAD
// export const abortUploadAPI = (payload) => {
//   return withAuthorization(async () => {
//     return axiosInstance.post("/api/admins/abort", payload);
//   });
// };


// // export async function getPhotoskeysbyidAPI(page, limit, bookingId = "", photographerId = "") {
// //   return withAuthorization(async () => {
    
// //     const response = await axiosInstance.get(
// //      `/api/admins/datalinks?page=${page}&limit=${limit}&bookingId=${bookingId}&photographerId=${photographerId}`
// //     );
// //     return response;
// //   });
// // }




// // export async function getImagesUsingKeysAPI(bookingId, key) {
// //   return withAuthorization(async () => {

    

// //     const response = await axiosInstance.get(
// //       `/api/admins/stream/${bookingId}/*${key}`,
// //       {
// //         responseType: "blob",
// //       }
// //     );

// //     const blobUrl = URL.createObjectURL(response.data);
// //     return blobUrl;
// //   });
// // }


// export function getImagesUsingKeysAPI(bookingId, key) {

//   const encodedKey = key
//     .split("/")
//     .map(encodeURIComponent)
//     .join("/");

//   return axiosInstance.get(
//       `/api/admins/stream/${bookingId}/*${encodedKey}`);
// }


// // export async function getPhotoskeysbyidAPI(page, limit, bookingId, photographerId) {
// //   return withAuthorization(async () => {
// //     const response = await axiosInstance.get(
// //      `/api/admins/datalinks?page=${page}&limit=${limit}&bookingId=${bookingId}&photographerId=${photographerId}`
// //     );
// //     return response;
// //   });
// // }

// // export async function getImagesUsingKeysAPI(bookingId, key) {
// //   return withAuthorization(async () => {
// //     const response = await axiosInstance.get(
// //       `/api/admins/stream/${bookingId}/*${key}`,
// //       {
// //         responseType: "blob",
// //       }
// //     );

// //     const blobUrl = URL.createObjectURL(response.data);
// //     return blobUrl;
// //   });
// // }

